import React, { useEffect } from 'react'
import queryString from 'query-string'
import { useDispatch, useSelector } from 'react-redux'
import { useParams, useLocation } from 'react-router-dom'
import { isEmpty } from 'lodash'

import { IconCircleCheckFilled, IconCircleDashedCheck } from '@tabler/icons-react'

import { Button } from '@/components/buttons/Button'
import { SearchableDropdown } from '@/components/dropdowns/SearchableDropdown'
import {
  fetchPlaylistsByCallId,
  fetchPlaylistsByMessageId,
  patchPlaylistCall,
} from '@/reducers/playlists/playlists.actions'

export const MarkAsReviewed = ({ callType = 'call' }) => {
  const dispatch = useDispatch()
  const { id: callId } = useParams()
  const { search } = useLocation()
  const { playlistUuid } = queryString.parse(search)
  const { playlistsByCallId, loading } = useSelector((state) => state.playlists)
  const playlistOptions = playlistsByCallId.map((playlist) => ({
    key: playlist.uuid,
    label: playlist.name,
    value: playlist.uuid,
    selected: playlist.is_flagged,
  }))

  const toggleReview = async (playlistUuid, isFlagged) => {
    const selectedPlaylist = playlistsByCallId.find((playlist) => playlist.uuid === playlistUuid)

    await dispatch(
      patchPlaylistCall(playlistUuid, selectedPlaylist.organization_id, callId, {
        is_flagged: !isFlagged,
        call_type: callType,
      })
    )

    if (callType !== 'call') {
      dispatch(fetchPlaylistsByMessageId(callId))
    } else {
      dispatch(fetchPlaylistsByCallId(callId))
    }
  }

  const handleToggleReviewed = async (playlistUuid) => {
    const row = playlistOptions.find((playlist) => playlist.key === playlistUuid)

    await toggleReview(playlistUuid, row.selected)
  }

  const renderButton = () => {
    const selectedPlaylist = playlistOptions.find((playlist) => playlist.key === playlistUuid)

    return (
      <Button
        small
        data-testid="mark-as-reviewed-button"
        onClick={async () => {
          await toggleReview(playlistUuid, selectedPlaylist.selected)
        }}
      >
        {selectedPlaylist?.selected ? (
          <IconCircleCheckFilled data-testid="reviewed-icon" className="fill-success" />
        ) : (
          <IconCircleDashedCheck data-testid="not-reviewed-icon" className="status-muted" />
        )}
        {selectedPlaylist?.selected ? 'Reviewed' : 'Review'}
      </Button>
    )
  }

  const isDisabled = isEmpty(playlistOptions)

  useEffect(() => {
    if (callType !== 'call') {
      dispatch(fetchPlaylistsByMessageId(callId))
    } else {
      dispatch(fetchPlaylistsByCallId(callId))
    }
  }, [callId])

  return playlistUuid ? (
    renderButton()
  ) : (
    <SearchableDropdown
      data-testid="mark-as-reviewed-dropdown"
      buttonLabel="Review"
      buttonProps={{ small: true }}
      additionalIcon={<IconCircleDashedCheck />}
      inputProps={{ placeholder: 'Search Playlists...' }}
      options={playlistOptions}
      loading={loading.playlistByCallId}
      handleSelect={handleToggleReviewed}
      isDisabled={isDisabled}
      disabledTooltip="Add call to a playlist to mark as reviewed"
    />
  )
}
